<template>
  <div
    class="card flex items-center mb-5 space-x-6"
  >
    <div class="shrink-0">
      <CircleProgress
        :size="80"
        :border-width="8"
        :border-bg-width="8"
        empty-color="#e5e7eb"
        fill-color="#6DB49B"
        :percent="100*achievements.net_footprint/$laravel.user.carbon_footprint"
      />
    </div>
    <div>
      <h2 class="mb-3 text-lg font-bold leading-snug text-gray-900">
        You Carbon Offset
      </h2>

      <div class="leading-snug text-gray-600">
        <p class="mb-2">
          <span>Your net carbon footprint is now </span>
          <b class="text-gray-900">{{ achievements.net_footprint }}&nbsp;Tons</b>.
        </p>
        <p>
          You have offset
          <b class="text-gray-900">{{ achievements.total_offset }}&nbsp;Tons</b>
          out of your
          <b class="text-gray-900">{{ $laravel.user.carbon_footprint }}&nbsp;Tons</b>
          annual footprint.
        </p>
        <a
          class="btn btn-info w-full mt-5 text-xs"
          href="https://carbonii.com/"
          target="_blank"
        >
          <span>
            See the projects we support
            <i class="mdi mdi-open-in-new" />
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";

export default {
  name: "v-achievements-net-footprint",
  components: {
    CircleProgress
  },
  props: {
    achievements: {
      type: Object,
      required: true
    }
  }
};
</script>
